var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rating" }, [
    _c(
      "div",
      { staticClass: "stars" },
      _vm._l(5, function (star) {
        return _c("span", { key: star, staticClass: "star" }, [
          _c("span", { staticClass: "star-bg" }, [_vm._v("★")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "star-fill",
              style: { width: _vm.starFill(star) + "%" },
            },
            [_vm._v("★")]
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("span", { staticClass: "rating-text" }, [
      _vm._v("\n    " + _vm._s(_vm.decimal) + " / 5\n    "),
      _vm.feedbackCount
        ? _c("span", [
            _vm._v(
              "(" +
                _vm._s(_vm.feedbackCount) +
                " " +
                _vm._s(_vm.feedbackCount === 1 ? "Bewertung" : "Bewertungen") +
                ")"
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }